module.exports = __webpack_public_path__ + "media/images/icons/douple-correct-icon-460c82b1f725790e3f0105b16263b53a.svg";